import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalClose() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-32 bg-beige relative overflow-hidden" data-id="element-43">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-16 bg-gradient-to-b from-gold/30 to-transparent" data-id="element-44"></div>

      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-46">
          <h2 className="text-3xl md:text-5xl font-serif text-navy leading-tight mb-12" data-id="element-47">
            "No necesitás más información. Necesitás un sistema probado que le
            enseñe a tu mente y a tu cuerpo a sentirse seguros otra vez."
          </h2>

          <button onClick={scrollToCheckout} className="w-full sm:w-auto px-12 py-5 bg-navy text-beige-light rounded-xl font-medium text-xl shadow-premium hover:shadow-premium-hover hover:-translate-y-1 transition-all duration-300 border border-gold/20 mb-16" data-id="element-48">
            QUIERO VOLVER A SENTIR PAZ
          </button>

          <div className="w-24 h-px bg-gold/50 mx-auto mb-16" data-id="element-49"></div>
        </motion.div>
      </div>
    </section>;
}